/**
 * @desc 新品下单-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productOrder.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
